// extracted by mini-css-extract-plugin
export default {"EmptyState":"SystemMessagesEmptyState_EmptyState__SaRcr","EmptyStateBold":"SystemMessagesEmptyState_EmptyStateBold__ErpYJ"};